import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import RoomsConsolidated from '../../../../components/rooms/RoomsConsolidated';

import { rooms as ROLES_CONFIG } from '../../../../config/roles';

export default class ConsolidatedRooms extends Component {

  constructor(props) {
    super(props);
    this.state = {
      role: this.props.authenticated ? this.props.authenticated.role : null,

    }
  }

  render() {
    return (
      <div id="content">
        <div className="row">
          {
            ROLES_CONFIG.roomsConsolidated.indexOf(this.state.role) != -1 ?
              <Paper className="col-md-11 ml-3-2vw h-100 mt-1vw p-0 customShadow" zDepth={3}>
                <RoomsConsolidated />
              </Paper> 
            : null
          }
        </div>
      </div>
    )
  }
} 


// WEBPACK FOOTER //
// ./routes/app/routes/rooms/ConsolidatedRooms.js